"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var Wrapper = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), function (_a) {
  var scSize = _a.scSize;
  return "" + polished_1.rem(scSize);
}, function (_a) {
  var scSize = _a.scSize;
  return "" + polished_1.rem(scSize);
});
var Inner = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  animation: rotate 1s infinite linear;\n  border: ", ";\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  animation: rotate 1s infinite linear;\n  border: ", ";\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme,
      scSize = _a.scSize,
      scColor = _a.scColor;
  return polished_1.rem(scSize / 6.5) + " solid " + (scColor !== null ? scColor : theme.color.primary);
});
var ContentWrapper = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var defaultProps = {
  size: 'm',
  color: null,
  className: ''
};

var Loader =
/** @class */
function (_super) {
  __extends(Loader, _super);

  function Loader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Loader.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        className = _a.className,
        color = _a.color;
    var sizeMapping = {
      m: 16,
      l: 24,
      xl: 40,
      xxl: 110
    };
    var sizeName = size in sizeMapping ? sizeMapping[size] : 16;
    return React.createElement(Wrapper, {
      className: className,
      scSize: sizeName,
      "data-testid": "Loader"
    }, React.createElement(Inner, {
      scSize: sizeName,
      scColor: color
    }));
  };

  Loader.defaultProps = defaultProps;
  return Loader;
}(React.PureComponent);

exports.Loader = Loader;

var ContentLoader =
/** @class */
function (_super) {
  __extends(ContentLoader, _super);

  function ContentLoader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ContentLoader.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        restProps = __rest(_a, ["className"]);

    return React.createElement(ContentWrapper, {
      className: className
    }, React.createElement(Loader, __assign({}, restProps)));
  };

  return ContentLoader;
}(React.PureComponent);

exports.ContentLoader = ContentLoader;
exports.default = styled_components_1.withTheme(Loader);
var templateObject_1, templateObject_2, templateObject_3;